import Cell from './Cell'

function Grid({ grid, statuses, revealAnimationRow, currentRow, letterPosition }) {
  let isActive = false;

  return (
    <div>
      {grid.map((row, rIndex) => (
        <div key={rIndex} style={{ display: "flex" }}>
          {row.map((letter, cIndex) => {
            let animate = "";

            // POP quand on écrit dans la ligne en cours
            if (rIndex === currentRow && letter !== "" && statuses[rIndex][cIndex] === "") {
              animate = "pop";
            }

            // FLIP ligne révélée
            if (rIndex === revealAnimationRow) {
              animate = "flip";
            }

            // Cell courante en rouge
            if (rIndex === currentRow && cIndex === letterPosition -1) isActive = true;
            else isActive = false;

            return (
              <Cell
                key={rIndex+'_'+cIndex}
                letter={letter}
                status={statuses[rIndex][cIndex]}
                animate={animate}
                isActive={isActive}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default Grid;